module.exports = __webpack_public_path__ + "static/img/ma8.c7d13d0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma8.gif
// module id = KRQZ
// module chunks = 1